import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { StationGroup } from '../../../../../components/station-selection/model/StationGroup';
import { StationSelectionLevel } from '../../../../../components/station-selection/model/StationSelectionLevel.enum';
import { StationSelection } from '../../../../../components/station-selection/model/station-selection';
import { ResponseStatus } from '@sdbn/common';
import { DictionaryKeySelectOption } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { CancellationStation, CancelTransport, TransportStationAssignment } from '../../model/sac-client.model';
import { SacClientService } from '../../service/sac-client.service';
import { TransportScope } from '../../../../../common/model/transport.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { min } from 'rxjs/operators';


export interface CancelTransportDialogData {
  assignment: TransportStationAssignment;
  stationForRepeatProcessing: CancellationStation[];
  stationForForwarding: StationGroup[];
  carrier: string;
  driver: string;
  identifier: string;
  transportScope: TransportScope;
}

@Component({
    selector: 'app-cancel-transport-dialog',
    templateUrl: './cancel-transport-dialog.component.html',
    styleUrls: ['./cancel-transport-dialog.component.scss'],
    standalone: false
})
export class CancelTransportDialogComponent implements OnInit {

  isLoading = false;

  responseMessages: ResponseMessage[];

  requiredSelectionLevels: StationSelectionLevel[] = [StationSelectionLevel.STATION_SET, StationSelectionLevel.STATION];

  viewModeRepeatProcessing = '0';
  viewModeForwardTransport = '1';
  selectedViewMode = this.viewModeRepeatProcessing;

  selectedStationForRepeat: any;
  selectedForwardingStation: StationSelection;
  selectedForwardingOption: DictionaryKeySelectOption;

  formGroup = new FormGroup({
    reason: new FormControl(null, [])
  });

  reason: string;

  constructor(
    public configurationService: AppClientConfigurationService,
    private sacClientService: SacClientService,
    public dialogRef: MatDialogRef<CancelTransportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelTransportDialogData,
    public translationService: TranslationService) { }

  ngOnInit() {

    let required = this.configurationService.isPropertyTrue('ui-component.station-assignment-client.cancel-transport-dialog.cause.min-length', true)
    if (required) {
      this.formGroup.controls['reason'].setValidators([Validators.required]);
      // TODO min length configurationService.getPropertyValue('ui-component.station-assignment-client.cancel-transport-dialog.cause.min-length', 1)"
    }

    if (this.data.stationForRepeatProcessing != null && this.data.stationForRepeatProcessing.length > 0) {
      this.selectedStationForRepeat = this.data.stationForRepeatProcessing[0];
    }

    this.formGroup.valueChanges.subscribe(value => {
      this.reason = value.reason;
      console.log('value is', value);
    });
  }

  onForwardingStationSelectionChanged(stationSelection: StationSelection) {
    this.selectedForwardingStation = stationSelection;
  }

  public forwardingOptionsChanged(event: DictionaryKeySelectOption) {
    this.selectedForwardingOption = event;
  }

  isCancelDisabled() {
    return false;
  }

  cancelDialog() {
    this.dialogRef.close();
  }

  isConfirmDisabled() {

    // console.log('reason is',
    //   this.reason,
    //   this.configurationService.isPropertyTrue('ui-component.station-assignment-client.cancel-transport-dialog.cause.min-length', true),
    //   this.reason == null,
    //   this.reason?.length === 0);

    if (this.selectedViewMode === this.viewModeRepeatProcessing) {

      let minLengthValue = this.configurationService.getPropertyValue('ui-component.station-assignment-client.cancel-transport-dialog.cause.min-length', '0');
      if (minLengthValue !== '0' && minLengthValue !== '') {

        if (this.reason == null) {
          return false;
        }

        if (this.reason.length < +minLengthValue) {
          return false;
        }

      }

      return !this.selectedStationForRepeat;
    }

    if (this.selectedViewMode === this.viewModeForwardTransport) {

      if (this.configurationService.isPropertyTrue('ui-component.station-assignment-client.cancel-transport-dialog.forwarding-cause.required', true)
        && this.selectedForwardingOption == null) {
        return true;
      }

      return this.selectedForwardingStation == null || !this.selectedForwardingStation.valid;
    }
  }

  confirm() {

    const ct = new CancelTransport();
    ct.transportStationAssignment = this.data.assignment;

    if (this.selectedViewMode === this.viewModeRepeatProcessing) {
      ct.canellationReason = this.reason;
      ct.targetStationForRepeat = { id: this.selectedStationForRepeat.id };
    }

    if (this.selectedViewMode === this.viewModeForwardTransport) {
      if (this.selectedForwardingStation.station != null) {
        ct.targetStationForForwarding = { id: this.selectedForwardingStation.station.id };
      } else if (this.selectedForwardingStation.stationSet != null) {
        ct.targetStationSetForForwarding = { id: this.selectedForwardingStation.stationSet.id };
      }
      ct.forwardingOptionDictionaryKey = this.selectedForwardingOption == null ?
        null : this.selectedForwardingOption.dictionaryKey;
    }

    this.isLoading = true;
    this.sacClientService.cancelTransport(ct).subscribe(result => {

      if (result.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close();
      }
      this.responseMessages = result.responseMessages;
      this.isLoading = false;
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }
}
